import { OrderEvent, Employee, Place, Product, Bill, OrderLine, OrderCancelationReason } from '../server-types';

interface BaseEventData {
    eventId: string;
    timestamp: Date;
}

export interface OrderCreated extends BaseEventData {
    eventType: OrderEvent.Created;
    details: {
        changedBy: Employee;
        place?: Place;
    };
}

export interface LinesAdded extends BaseEventData {
    eventType: OrderEvent.OrderLinesAdded;
    details: {
        orderLines: OrderLine[];
    };
}

export interface PaidPartially extends BaseEventData {
    eventType: OrderEvent.PaidPartially;
    details: {
        bill: Bill;
        orderLines: OrderLine[];
    };
}
export interface PaidCompletely extends BaseEventData {
    eventType: OrderEvent.PaidCompletely;
    details: {
        bill: Bill;
        changedBy: Employee;
        orderLines: OrderLine[];
    };
}

export interface OrderClosed extends BaseEventData {
    eventType: OrderEvent.PaidCompletely;
    details: {
        changedBy: Employee;
        place?: Place;
    };
}
export interface CanceledPartially extends BaseEventData {
    eventType: OrderEvent.CanceledPartially;
    details: {
        changedBy: Employee;
        orderLines: OrderLine[];
    };
}
export interface CanceledCompletely extends BaseEventData {
    eventType: OrderEvent.CanceledCompletely;
    details: {
        changedBy: Employee;
        orderLines: OrderLine[];
        reason: OrderCancelationReason;
    };
}
export interface MovedPartially extends BaseEventData {
    eventType: OrderEvent.MovedPartially;
    details: {
        changedBy: Employee;
        place: Place;
        orderLines: OrderLine[];
    };
}
export interface MovedCompletely extends BaseEventData {
    eventType: OrderEvent.MovedCompletely;
    details: {
        changedBy: Employee;
        place: Place;
    };
}
export interface QuickSale extends BaseEventData {
    eventType: OrderEvent.QuickSale;
    details: {
        orderLines: OrderLine[];
        bill: Bill;
    };
}

export interface EntitiesToQuery {
    orderLine: Record<string, OrderLine>;
    employee: Record<string, Employee>;
    place: Record<string, Place>;
    product: Record<string, Product>;
}

export type TimelineEvent = OrderCreated | LinesAdded | PaidPartially |
PaidCompletely | CanceledPartially | CanceledCompletely |
MovedPartially | MovedCompletely | QuickSale;

export const isPaidPartiallyGuard = (props: LinesAdded | PaidPartially | CanceledPartially): props is PaidPartially => {
    return (props as PaidPartially).eventType === OrderEvent.PaidPartially;
};

export const isCanceledCompletely = (
    props: OrderCreated | MovedCompletely | CanceledCompletely | OrderClosed
): props is CanceledCompletely => {
    return (props as CanceledCompletely).eventType === OrderEvent.CanceledCompletely;
};
